import './NavBar.scss';

import {NavLink} from "react-bootstrap";
import {NavLink as Link} from "react-router-dom";
import {NavigationBar} from "./NavigationBar";
import {buildUrl, EXPLORER, PLATFORM_HOME} from "../../services/PageUtils";

import HomeIcon from "../../icons/HomeIcon";
import {IconSize} from "../../services/IconConstants";
import StarSquareIcon from "../../icons/StarSquareIcon";

interface Props {
    logOut: () => void
    isLocked: boolean
}

const PlatformNavBar = ({logOut, isLocked}: Props) => {

    return (
        <NavigationBar logOut={logOut}>
            <NavLink as={Link} to={buildUrl(PLATFORM_HOME)} disabled={isLocked} end>
                <HomeIcon size={IconSize.md} />
                <div>Dashboard</div>
            </NavLink>
            <NavLink as={Link} to={buildUrl(EXPLORER)} disabled={isLocked} end>
                <StarSquareIcon size={IconSize.md} />
                <div>Reviews</div>
            </NavLink>
        </NavigationBar>
    )
}

export default PlatformNavBar;